import { useEffect } from 'react';
import { useGetDeviceType } from 'src/hooks/useGetDeviceType';
import { MAX_MOBILE_WIDTH } from 'src/utils/constants';
import { deviceWidth } from '@/utils/deviceWidth';

export default function useAnchorTop({ productId, productName }) {
  const { isMobile } = useGetDeviceType();

  useEffect(() => {
    // This is done as a fallback to stop any scroll anchor executed by Nextjs
    const bodyElement = document.getElementsByTagName('body')[0];
    if (bodyElement && (isMobile || deviceWidth <= MAX_MOBILE_WIDTH)) {
      bodyElement.classList.add('!tw-overflow-hidden');
      setTimeout(() => {
        bodyElement.classList.remove('!tw-overflow-hidden');
      }, 1100);
    }
  }, []);

  useEffect(() => {
    setTimeout(() => {
      window.scrollTo({ left: 0, top: 0 });
    }, 30);
  }, [productId, productName]);

  return null;
}
